// fetchProductDetail.js
'use strict';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';

import {
  MERGE_PRODUCT_DATA,
  ADD_DIAMOND_PACKS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch product detail
 * @kind action
 * @param {string} {productId} - product id.
 * @param {object} {[httpProxyHeaders = {}]} - http proxy headers for SSR.
 * @return {Promise} Action promise.
 */
const fetchProductDetail =
  ({ productId, httpProxyHeaders = {} } = {}) =>
  async dispatch => {
    if (!productId) {
      return dispatch({ type: '' });
    }
    const networkingSelectPath = ['fetch', 'product', productId];
    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
        ...httpProxyHeaders,
      },
    };
    const fetchUrl = getResourceUrl({
      endpoint: `/shop/products/${productId}`,
    });
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        await handleFetchError({ response });
      }
      const payload = (await response.json()) || {};
      const skus = payload.skus || [];
      // currencySkuIdMap
      // {
      //   TWD: 'nino-pack-diamonds-1fb1606e75f6cb4ca2101b0c6aadcc7d',
      //   DIAMONDS: 'nino-pack-diamonds-1fb1606e75f6cb5ca2101b0c6aadcc7d'
      // }
      const currencySkuIdMap = skus.reduce((accumulator, sku) => {
        const { currency, id } = sku;
        accumulator[currency] = id;
        return accumulator;
      }, {});
      const product = {
        ...payload,
        skuIds: skus.map(sku => sku.id),
        currencySkuId: currencySkuIdMap,
      };
      delete product.skus;
      dispatch({
        type: MERGE_PRODUCT_DATA,
        payload: {
          selectPath: [productId],
          data: product,
        },
      });
      dispatch({
        type: ADD_DIAMOND_PACKS,
        payload: {
          diamondPacks: objectifyArrayById({
            array: skus.map(sku => ({
              ...sku,
              productId,
              productType: product.type,
            })),
          }),
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchProductDetail;
